// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2KHqZ","label":"CategoryService_label__1vDqW","location":"CategoryService_location__3dwf_"};